import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login.tsx";
import Otp from "./pages/Otp.tsx";
import Response from "./pages/Response.tsx";
import EmiTenure from "./pages/EmiTenure.tsx";
import LenderCallback from "./pages/LenderCallback.tsx";
import DownPayment from "./pages/DownPayment.tsx";
import NotFound from "./pages/NotFound.tsx";
import { ThemeProvider } from "./context/ThemeContext";
import { useEffect } from "react";

function App() {
  // No need for useState token here — rely on sessionStorage
  const getSessionToken = () => sessionStorage.getItem('token');

  type ProtectedRouteProps = {
    children: React.ReactNode; // ✅ Use React.ReactNode instead of JSX.Element
  };

  const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const token = getSessionToken();
    return token ? <>{children}</> : <NotFound />;
  };

  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e: MouseEvent) => e.preventDefault();
    document.addEventListener('contextmenu', handleContextMenu);

    // Disable common DevTools shortcuts
    const handleKeyDown = (e: KeyboardEvent) => {
      // F12
      if (e.key === 'F12') e.preventDefault();
      // Ctrl+Shift+I / Cmd+Opt+I
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key.toLowerCase() === 'i') e.preventDefault();
      // Ctrl+Shift+C / Cmd+Opt+C
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key.toLowerCase() === 'c') e.preventDefault();
      // Ctrl+U / Cmd+U
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'u') e.preventDefault();
    };
    document.addEventListener('keydown', handleKeyDown);

    // Disable copy/cut/paste
    const handleCopyCutPaste = (e: ClipboardEvent) => e.preventDefault();
    document.addEventListener('copy', handleCopyCutPaste);
    document.addEventListener('cut', handleCopyCutPaste);
    document.addEventListener('paste', handleCopyCutPaste);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('copy', handleCopyCutPaste);
      document.removeEventListener('cut', handleCopyCutPaste);
      document.removeEventListener('paste', handleCopyCutPaste);
    };
  }, []);


  return (
    <ThemeProvider>
      <div className="min-h-screen text-black transition-colors bg-white dark:bg-dark dark:text-dark">
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/transactionstatusoffline"
              element={

                <LenderCallback />

              }
            />
            <Route
              path="/downpayment"
              element={

                <DownPayment />

              }
            />


            {/* Protected Routes */}
            <Route
              path="/otp"
              element={
                <ProtectedRoute>
                  <Otp />
                </ProtectedRoute>
              }
            />
            <Route
              path="/response"
              element={
                <ProtectedRoute>
                  <Response />
                </ProtectedRoute>
              }
            />
            <Route
              path="/success"
              element={
                <ProtectedRoute>
                  <Response />
                </ProtectedRoute>
              }
            />
            <Route
              path="/fail"
              element={
                <ProtectedRoute>
                  <Response />
                </ProtectedRoute>
              }
            />
            <Route
              path="/emi-tenure"
              element={
                <ProtectedRoute>
                  <EmiTenure />
                </ProtectedRoute>
              }
            />


            {/* Catch-all for unknown routes */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
